import React from 'react';
import { Box, TextField, Typography, Button } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import CustomAppBar from '../components/CustomAppBar';
import PrimaryButton from '../components/PrimaryButton';
import Navbar from '../components/Navbar';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { updateTempGroupName } from '../redux/groupSlice';
// validation
import { Formik, ErrorMessage, Field, Form } from 'formik';
import { groupNameSchema } from '../validation/schemas';


function NewGroupName() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleFormSubmit = (values, {setSubmitting}) => {
        console.log("Values", values);
        setSubmitting(false); // Set submitting to false after delay

        // dispatch the new temp group name in store
        dispatch(updateTempGroupName(values.name));

        navigate('/new-group/add-hearts');
    }

    return (
        <AppContainer>
            <Formik
                initialValues={{ name: '' }}
                validationSchema={groupNameSchema}
                onSubmit={handleFormSubmit}
            >
            {({ isSubmitting, errors, touched }) => (
                <Form>
                    <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>
                        <CustomAppBar />
                        {/* Box to fill space, pushing button to bottom of screen */}
                        <Box style={{ flex: 1 }}>
                            <Navbar rightButtonIcon={<CloseIcon />} rightButtonOnClick={() => {navigate('/home')}} />
                            <TextContainer>
                                <Typography variant='h5'>Name the group</Typography>
                                <Field 
                                    as={TextField}
                                    id='name'
                                    name='name'
                                    sx={{width: '100%'}} 
                                    label="Enter Group Name"
                                    variant="filled" 
                                    error={errors.name && touched.name}
                                />
                                <ErrorMessage name="name" component="div" style={{ color: 'red' }} />
                            </TextContainer>
                        </Box>
                        {/* Button at the bottom of the screen */}
                        <TextContainer customStyles={{marginBottom: '40px'}}>
                            {/* Verify that group name is valid */}
                            <Button 
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                sx={{width: '100%'}}
                            >
                                Next
                            </Button>
                        </TextContainer>
                    </Box>
                </Form>
            )}
            </Formik>
        </AppContainer>
    )
}

export default NewGroupName